import { show } from "@intercom/messenger-js-sdk";
import {
  IconHelpCircle,
  IconPhoto,
  IconUser,
  IconMusic,
  IconSquares,
} from "@tabler/icons-react";
import { cn } from "@/lib/utils";

type Props = {
  activeTab: string;
  onTabChange: (tab: string) => void;
};

export const editorPanelTabs = [
  {
    label: "Images",
    value: "images",
    icon: <IconPhoto key="photo" size={20} strokeWidth={1.5} />,
  },
  {
    label: "Voiceover",
    value: "voiceover",
    icon: <IconUser key="user" size={20} strokeWidth={1.5} />,
  },
  {
    label: "Music",
    value: "music",
    icon: <IconMusic key="music" size={20} strokeWidth={1.5} />,
  },

  {
    label: "Overlays",
    value: "overlays",
    icon: <IconSquares key="squares" size={20} strokeWidth={1.5} />,
  },
];

export default function TabNavigation({ activeTab, onTabChange }: Props) {
  return (
    <div className="flex h-full w-24 flex-col items-center gap-2 rounded-2xl bg-white px-2 py-2 shadow-card">
      {editorPanelTabs.map((tab) => (
        <TabNavigationItem
          key={tab.value}
          {...tab}
          onClick={onTabChange}
          isActive={activeTab === tab.value}
        />
      ))}
      <div className="flex-1"></div>
      <TabNavigationItem
        label="Support"
        value="support"
        onClick={() => show()}
        isActive={false}
        icon={<IconHelpCircle className="h-6 w-6 text-text-secondary" />}
      />
    </div>
  );
}

type TabNavigationItemProps = {
  label: string;
  value: string;
  onClick: (value: string) => void;
  isActive: boolean;
  icon: React.ReactNode;
};

function TabNavigationItem({
  label,
  value,
  onClick,
  isActive,
  icon,
}: TabNavigationItemProps) {
  return (
    <button
      className={cn(
        "flex h-16 w-full cursor-pointer flex-col items-center justify-center gap-1 rounded-lg border",
        isActive
          ? "[&_svg]:stroke-[url(#icon-gradient)]"
          : "border-transparent text-text-secondary transition-colors duration-200 hover:bg-grey-100",
      )}
      style={
        isActive
          ? {
              background:
                "linear-gradient(to right, var(--color-primary-100), var(--color-secondary-100)) padding-box, linear-gradient(to right, color-mix(in srgb, var(--color-primary-400), transparent 90%), color-mix(in srgb, var(--color-secondary-400), transparent 90%)) border-box",
              border: "1px solid transparent",
              borderRadius: "0.5rem",
            }
          : undefined
      }
      onClick={() => onClick(value)}
    >
      {icon}
      <span
        className={cn(
          "inline-block text-xs font-medium select-none",
          isActive
            ? "bg-linear-to-r from-primary-400 to-secondary-400 bg-clip-text text-transparent"
            : "text-text-secondary",
        )}
      >
        {label}
      </span>
    </button>
  );
}
